<template>
  <div>
    <div v-if="showSpinner" class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div v-else-if="historyItems.length > 0 " class="border-top border-bottom">
      <div
        class="row mt-2"
        :class="idx == historyItems.length - 1 ? 'mb-2' : ''"
        v-for="(itm, idx) in historyItems"
        :key="idx"
      >
        <div class="col" style="justify-content: center;padding: 10px 0 10px 0;display: flex;">
          <span
            v-if="itm.rrOptionStatusId != 1000"
            class="historyText"
          >{{FormatDate(itm.statusDate)}}</span>
        </div>
        <div class="col border-left" style="justify-content: center;padding: 10px 5px;display: flex;flex-wrap: wrap;">
          <span class="historyText">{{itm.rrOptionStatusLabel}}</span>
          <div v-if="itm.rrOptionStatusId == 1004 && trackingId" style="min-width: 100%;justify-content: center;display: flex;">
            <small class="text-muted">Tracking ID: {{trackingId}}</small>
          </div>
          <div v-if="itm.rrOptionStatusId == 1008 && excessAmount" style="min-width: 100%;justify-content: center;display: flex;">
            <small class="text-muted">Amount: {{excessAmount}}</small>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span>Unavailable</span>
    </div>
  </div>
</template>

<script>
import { repairOptionsService } from "@/services/repairOptions-api.service.js";
import moment from "moment";

export default {
  name: "SelectedOptionStatus",
  props: {
    gadgetWebReference: { required: true },
    trackingId: { required: false, default: null},
    excessAmount: { required: false, default: null}
  },
  data() {
    return {
      loading: true,
      historyItems: []
    };
  },
  mounted() {
    this.getSelectedOptionStatusHistory(this.gadgetWebReference);
  },
  computed: {
    showSpinner() {
      if (this.historyItems.length == 0 && this.loading == true) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async getSelectedOptionStatusHistory(id) {
      try {
        repairOptionsService
          .getSelectedStatusHistory(id)
          .then(response => {
            let { data } = response;
            if (data && data.length > 0) {
              this.historyItems = data;
            }
            this.loading = false;
          })
          .catch(err => {
            console.log("getSelectedOptionStatusHistory: ", err);
          });
      } catch (err) {
        this.loading = false;
      }
    },
    FormatDate(dte) {
      if (dte) return moment(dte).format("DD/MM HH:mm")

      return "UNAVAILABLE";
    }
  },
  watch: {}
};
</script>
<style scoped>
.historyText {
  font-size: 1rem;
  font-weight: 300;
}
</style>